import React from 'react'

import { Div } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import { ReactComponent as LightningIcon } from '../../svgs/lightning.svg'

import { EDUCATION_COPY } from './constants'

import styles from './styles.module.css'

interface EducationProps {
  type: string
  onClose: () => void
}

const Education: React.FC<EducationProps> = ({ type, onClose }) => {
  const { title, body, imgUrl } = EDUCATION_COPY[type]

  return (
    <Div className={styles.educationContainer}>
      <Div className={styles.educationCloseButton} onClick={onClose}>
        <Icon name="close" width={13} height={13} />
      </Div>
      <Div className={type === 'ACTIVITY_TIMELINE' ? styles.topArrow : styles.rightArrow} />
      <img className={styles.educationImg} alt="" src={imgUrl} loading="lazy" />
      <Div className={styles.educationNew}>
        <LightningIcon height="16" className={styles.lightningSVG} />
        <span>NEW!</span>
      </Div>
      <Div className={styles.educationTitle}>{title}</Div>
      <Div className={styles.educationBody}>{body}</Div>
    </Div>
  )
}

export default Education
